import { BackButton, Button, StyledText } from "../../../../components/common";
import { useTheme } from "../../../../hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import PeerTalkIcons from "../components/PeerTalkIcons";

const PeerTalkInfo = ({ onBackButtonClick }) => {
  const { themeContext, theme } = useTheme();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let history = useHistory();

  return (
    <div
      style={{
        position: "absolute",
        zIndex: 100,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.7)",
      }}
    >
      <div
        style={{
          boxSizing: "border-box",
          padding: "20px",
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          paddingInline: 15,
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            paddingLeft: "38%",
            backgroundColor: "white",
            width: "100%",
            height: 50,
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
          }}
        >
          <StyledText
            style={{
              fontSize: 24,
              fontFamily: "MTNMedium",
            }}
          >
            PeerTalk
          </StyledText>
          <BackButton onClick={() => history.goBack()} />
        </div>
        <div style={{ marginTop: "20%" }}>
          <PeerTalkIcons />
          <div>
            <StyledText style={{ fontSize: 22, fontFamily: "MTNMedium" }}>
              What is PeerTalk?
            </StyledText>
          </div>
          <StyledText
            style={{
              fontFamily: "MTNMedium",
            }}
          >
            PeerTalk is an anonymous community for Pulsers like you to get
            answers to your questions and also share your thoughts
          </StyledText>

          <OutlinedContainer color={background}>
            <StyledText style={{ fontFamily: "MTNMedium", fontSize: 18 }}>
              How to send your questions
            </StyledText>

            {howToSendYourQuestion.map((note, index) => {
              return (
                <TipsContainer key={index}>
                  <CircleContainer>
                    <Dot color={background} />
                  </CircleContainer>
                  <StyledText
                    style={{ marginBlockStart: 0, fontFamily: "MTNRegular" }}
                  >
                    {note}
                  </StyledText>
                </TipsContainer>
              );
            })}
          </OutlinedContainer>
          <OutlinedContainer color={background}>
            <StyledText style={{ fontFamily: "MTNMedium", fontSize: 18 }}>
              How to participate
            </StyledText>

            {howToPartcipate.map((note, index) => {
              return (
                <TipsContainer key={index}>
                  <CircleContainer>
                    <Dot color={background} />
                  </CircleContainer>
                  <StyledText
                    style={{ marginBlockStart: 0, fontFamily: "MTNRegular" }}
                  >
                    {note}
                  </StyledText>
                </TipsContainer>
              );
            })}
          </OutlinedContainer>

          <ButtonContainer>
            <Button
              style={{ backgroundColor: background, width: "80%" }}
              onClick={() => history.push("/peer_talk/")}
            >
              <StyledText color="white">EXPLORE YOUNGSTER PULSE</StyledText>
            </Button>
          </ButtonContainer>
        </div>
      </div>
    </div>
  );
};

export default PeerTalkInfo;

const OutlinedContainer = styled.div`
  width: "90%";
  border-width: 2;
  border: 1.5px solid ${({ color }) => color};
  border-radius: 15px;
  padding-inline: 10px;
  margin-top: 15px;
`;

const TipsContainer = styled.div`
  display: flex;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-inline: 10px;
  margin-top: 5px;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
  margin-right: 10px;
`;

const howToSendYourQuestion = [
  "Share your questions with the PeerTalk through the social media handles of MTN Ghana and add the hashtag #YoungsterPulse",
];
const howToPartcipate = [
  "Read Youngster Pulse stories in the Pulse app and share with your friends.",
  "Leave your comments anonymously on the stories you read and remember to always be positive",
  "Send your questions to Youngster Pulse on MTN Ghana social media handles with the hashtag #YoungsterPulse",
];
